import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import desktopBackground from "../../assets/images/desktopBackground.png";
import closepayLogo from "../../assets/images/closepayLogo.png";
import bsi from "../../assets/images/bsi.png";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";

import Company from "../../core/models/company";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setLoading } from "../../core/feature/config/configSlice";
import { BrowserView, MobileView, isBrowser } from "react-device-detect";

import HomeMobile from "./homeMobile";
import HomeWeb from "./homeWeb";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
import User from "../../core/models/user";

import * as api_balance from "../../core/service/api_balance";
import { useDispatch } from "react-redux";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import {
  removeBalance,
  setBalance,
} from "../../core/feature/user/balanceSlice";
import { setCustomApp } from "../../core/feature/company/customAppsSlice";
import CustomApp from "../../core/models/customApp";
import IconApp from "../../core/models/iconApp";
import { setIconApp } from "../../core/feature/company/iconAppSlice";
import { removeToken, setToken } from "../../core/feature/token/tokenSlice";
import { i18n } from "../../translations/i18n";
import { setLanguage } from "../../core/feature/language/languageSlice";

const Home = () => {
  const gaEventTracker = useAnalyticsEventTracker("Home");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [finish, setFinish] = useState(false);
  const token: String = useAppSelector((state) => state.token.token);
  const iconApp: IconApp = useAppSelector((state) => state.iconApp.iconApp);
  const language: String = useAppSelector((state) => state.language.language);

  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );

  const [handleSVG, sethandleSvg] = useState<any>({});

  const user: User = useAppSelector((state) => state.user.user);  
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Home",
    });
    let x = localStorage.getItem("user_redux")  
    if(x === null && location.pathname.split("/")[2] == undefined){
      navigate("/login", { replace: true });
      setFinish(true)
    } else {
      if(isBrowser){
        if(location.pathname.split("/")[2] != undefined){
          dispatch(setToken(location.pathname.split("/")[2]))
        }
        var bahasa = "";
        if (location.pathname.split("/")[3] != undefined) {
          var lang = location.pathname.split("/")[3];
          i18n.changeLanguage(lang);
          dispatch(setLanguage(lang));
          bahasa = location.pathname.split("/")[3].toUpperCase();
        }
        if(bahasa == ""){
          bahasa = language.toString()
        }
        API.credentialCheck()
        .then((resCredential: any) => {
          dispatch(setUser(resCredential.data.user));
          api_balance
            .getBalance()
            .then((balance) => {
              dispatch(setBalance(balance.data.balance));
              api_balance
                .getBalance()
                .then((res) => {
                  dispatch(setBalance(res.data.balance));
                  console.log("hai")
                  API.getCustomApps(
                    resCredential.data.activeCompany.id,
                    bahasa.toUpperCase()
                  ).then((resCustom: any) => {
                    console.log(resCustom.data);
                    let tempResCustom = resCustom.data;
                    if (!resCredential.data.activeCompany.customApps) {
                      tempResCustom.app_display_name =
                        resCredential.data.activeCompany.name;
                      tempResCustom.app_icon_url = "psp.svg";
                      tempResCustom.app_mobile_background_header_url =
                        "header.svg";
                      tempResCustom.app_desktop_background_header_url =
                        "header.svg";
                      tempResCustom.app_accent_color = "#0054E6";
                      tempResCustom.app_secondary_accent_color = "#0054E6";
                    }

                    const hasBsiAndNotActive = tempResCustom.app_menu.some(
                      ({
                        menu_name,
                        menu_is_show,
                      }: {
                        menu_name: string;
                        menu_is_show: boolean;
                      }) =>
                        menu_name.toLowerCase().includes("bsi") && !menu_is_show
                    );
                    console.log(hasBsiAndNotActive);
                    console.log(
                      resCredential.data.activeCompany.banks.includes("BSI")
                    );
                    if (
                      resCredential.data.activeCompany.banks.includes("BSI") &&
                      hasBsiAndNotActive
                    ) {
                      // tempResCustom.app_menu.push({
                      //   id: "63dfc62c31bd560297c12397",
                      //   menu_name: "BSI Burekol",
                      //   menu_path: "https://bsi-burekol.dev.teknologikartu.com/Home",
                      //   menu_icon_url: "bsi_burekol.svg",
                      //   menu_is_show: true,
                      //   menu_type: "URL"
                      // });
                      console.log("adding BSI Tambahan");
                    }
                    
                    dispatch(setCustomApp(tempResCustom));
                    
                    if (!iconApp || Object.keys(iconApp).length < 1) {
                      getIconApp(tempResCustom);
                    } else {
                      sethandleSvg(iconApp);
                    }
                    setFinish(true)
                    navigate("/home", { replace: true });
                  });
                })
                .catch((err) => {
                  // dispatch(removeUser());
                  dispatch(removeBalance());
                //   navigate("/login", { replace: true });
                });
            })
            .catch((err) => {
              // dispatch(removeUser());
              dispatch(removeBalance());
            //   navigate("/login", { replace: true });
            });
        })
        .catch((err) => {        
          dispatch(removeBalance());
        });
      }else{
        setFinish(true)
      }
    }
  }, []);
  const getIconApp = async (customData: any = null) => {
    let result: any = {};

    let tempCustomApp: any = customApp?.app_menu.filter(
      (filter: any) => filter.menu_is_show == true
    );

    if (customApp == undefined) {
      for (let index = 0; index < tempCustomApp.length; index++) {
        console.log(tempCustomApp[index].menu_name);
        await API.getIconApps(
          customData.company_id,
          tempCustomApp[index].menu_icon_url
        ).then((res) => {
          result[tempCustomApp[index].id] = res.data;
        });
      }
      dispatch(setIconApp(result));
      sethandleSvg(result);
    } else {
      console.log(customApp, `line 286, length ${customApp.app_menu.length}`);
      console.log(tempCustomApp, `line 287, length ${tempCustomApp.length}`);
      for (let index = 0; index < tempCustomApp.length; index++) {
        console.log(tempCustomApp[index].menu_icon_url);
        await API.getIconApps(
          customApp?.company_id,
          tempCustomApp[index].menu_icon_url
        ).then((res) => {
          result[tempCustomApp[index].id] = res.data;
        });
      }
      dispatch(setIconApp(result));
      sethandleSvg(result);
    }
  };
  return (
    <>
      <BrowserView>
        {/* {
          user && finish && <HomeWeb></HomeWeb>
        } */}
        {
          user && <HomeWeb></HomeWeb>
        }
      </BrowserView>
      <MobileView>
          <HomeMobile></HomeMobile>
      </MobileView>
    </>
  );
};

export default Home;
